import { Pipe, PipeTransform } from "@angular/core";
import { ButtonVariant } from "../button/button.component";

@Pipe({
    name: "mapCardToButtonVariant",
})
export class MapCardToButtonVariantPipe implements PipeTransform {
    transform(variant: string): ButtonVariant {
        switch (variant) {
            case "sale":
                return "orange";
            case "design":
                return "green";
            case "bestseller":
                return "blue";
            default:
                return "default";
        }
    }
}
